<template>
  <div class="commonDialogBody">
    <el-dialog
        :close-on-click-modal='false'
        :title="title"
         :visible.sync="dialogVisible"
        width="50%"
        :destroy-on-close="true"
        :before-close="handleClose">
        <div style="width:100%;">
          <el-table  :data="tableData" tooltip-effect="light" show-summary  style="overflow-y: scroll;float:right;margin-top:30px" 
            row-key="id" border  :default-expand-all="false" :stripe="true" :tree-props="{children: 'children'}">
            <el-table-column show-overflow-tooltip prop="address" label="地址"  ></el-table-column>
            <el-table-column show-overflow-tooltip prop="zjCny" label="收款年月"></el-table-column>
            <el-table-column show-overflow-tooltip prop="feeItem.feeName" label="收款项目"></el-table-column>
            <el-table-column show-overflow-tooltip prop="zjJe" label="收款金额"></el-table-column>
            <el-table-column show-overflow-tooltip prop="zjSkrqDate" label="收款日期"></el-table-column>
            <el-table-column show-overflow-tooltip prop="zjJzrqDate" label="结账日期"></el-table-column>
            <el-table-column show-overflow-tooltip prop="zjTzrqDate" label="调整日期"></el-table-column>
            <el-table-column show-overflow-tooltip prop="zjBdrqDate" label="补打日期"></el-table-column>
            <el-table-column show-overflow-tooltip prop="zjTkrqDate" label="退款日期"></el-table-column>
            <el-table-column show-overflow-tooltip prop="zjRemarks" label="备注"></el-table-column>
          </el-table>
        </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="modification()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
 components: {},
  name: "AnnualSummaryDialog",
  data() {
    return {
     dialogVisible: false,
     title:"标题",
     labelPosition:'right',
     tableData:[],
    };
  },
  watch:{
    dialogVisible(val){
      if(val == true){
        for(let res of this.tableData){
          if(res.zjSkrq != null){
             res.zjSkrqDate = res.zjSkrq.replace("T"," ").substring(0,19)
          }
          if(res.zjBdrq != null){
             res.zjBdrqDate = res.zjBdrq.replace("T"," ").substring(0,19)
          }
          if(res.zjTzrq != null){
             res.zjTzrqDate = res.zjTzrq.replace("T"," ").substring(0,19)
          }
          if(res.zjTkrq != null){
             res.zjTkrqDate = res.zjTkrq.replace("T"," ").substring(0,19)
          }
          if(res.zjJzrq != null){
            res.zjJzrqDate = res.zjJzrq.replace("T"," ").substring(0,19)
          }
        }
      }
    }
  },
  methods: {
    modification(){
       this.dialogVisible = false
    },
    handleClose(done) {
      this.dialogVisible = false
    },
  },
    //组件创建之后
  created() {

  },
}
</script>

<style scoped lang="scss">
// .commonDialogBody {

// }
</style>